export const brl = (n: number) => n.toLocaleString('pt-BR');
